import React from 'react';
import Text from './Text';

export default function WebLink({
    url,
    children,
    style,
    newTab = false,
}: {
    url: string;
    children?: string;
    style?: React.CSSProperties;
    newTab?: boolean;
}) {
    return (
        <Text textStyle={style}>
            <a
                style={{ fontFamily: 'inherit', fontSize: 'inherit', color: 'inherit', textDecoration: 'underline' }}
                href={url}
                target={newTab ? '_blank' : undefined}
                rel="noopener noreferrer"
            >
                {children ? children : url}
            </a>
        </Text>
    );
}
